'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcElementState
* @element ANY
* @description
* Allows element state to be preserved.
* Variable for state value must be passed to the directive (e.g. Reference to a $scope.viewModel variable)
*/
angular.module('tcApp')
.directive('tcElementState', function($parse, $log, ElementStateService) {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			var elementId = attrs.id;
			if ((angular.isUndefined(elementId)) || (elementId === '')) {
				$log.warn('tcElementState: Element must have an id to be used as a key for element state', element);
				return;
			}
			var elementState = attrs.tcElementState;
			if ((angular.isUndefined(elementState)) || (elementState === '')) {
				$log.warn('tcElementState: Variable for element state must be provided', element);
				return;
			}
			var isPersistant = angular.isDefined(attrs.tcElementStatePersistant);
			// Allow an expression to suppress the element state mechanism
			if (angular.isDefined(attrs.tcElementStateIf)) {
				if (!$parse(attrs.tcElementStateIf)(scope)) return;
			}

			// Load the state for the element from the cache.
			// Note: If this is overidden by other directives, the other directive may need to check the state
			// (e.g. Accordion initial collapsed value)
			var state;
			if (isPersistant) {
				state = ElementStateService.getPersistant(elementId);
			} else {
				state = ElementStateService.get(elementId);
			}
			if (angular.isDefined(state)) {
				//$log.debug('state loaded', elementId, elementState, state);
				scope.$eval(elementState + '=' + state);
			}

			scope.$watch(elementState, function ElementStateChangeHandler(elementStateValue) {
				if (angular.isDefined(elementStateValue)) {
					//$log.debug('state changed', elementId, elementStateValue);
					if (isPersistant) {
						ElementStateService.setPersistant(elementId, elementStateValue);
					} else {
						ElementStateService.set(elementId, elementStateValue);
					}
				} else {
					if (!isPersistant) {
						ElementStateService.removeKey(elementId);
					}
				}
			});
		}
	};
});
